import { render, staticRenderFns } from "./CeremonyCollectionDock.vue?vue&type=template&id=3438310c&scoped=true"
import script from "./CeremonyCollectionDock.vue?vue&type=script&lang=js"
export * from "./CeremonyCollectionDock.vue?vue&type=script&lang=js"
import style0 from "./CeremonyCollectionDock.vue?vue&type=style&index=0&id=3438310c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3438310c",
  null
  
)

export default component.exports